import { TAO_KOE } from './../libs';
import VideoPopup from './video-popup';
import { handleLazyLoad } from './video-lazy.js';

// Video Utility Object.
const Video = {

};

Video.extract_video_url = function( url ) {
	if ( url && url !== null && url !== 0 ) {
		//First try for youtube
		let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
		let match = url.match( regExp );
		if ( match && match[ 2 ].length === 11 ) {
			return 'https://www.youtube.com/embed/' + match[ 2 ];
		}

		//else Vimeo
		regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
		match = url.match( regExp );
		if ( match && match[ 5 ] ) {
			return 'https://player.vimeo.com/video/' + match[ 5 ];
		}
		return false;
	}
	return false;
};

Video.is_youtube = function( content ) {
	return -1 !== content.search( 'youtu' );
};

Video.is_vimeo = function( content ) {
	return -1 !== content.search( 'vimeo' );
};

Video.getPopup = function() {
	return VideoPopup.getInstance();
};

Video.closePopup = function() {
	const Popup = VideoPopup.getInstance();
	Popup.close();
};

Video.handleLazyLoad = handleLazyLoad;

// Expose
TAO_KOE.Video = Video;

// Export
export {
	Video as default,
};
